import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DocumentItem from "../../../Components/Masters/DocumentItem";
import { formatDate } from "../../../utils/formatDate";

function ViewData({
  title,
  inputData,
  element,
  viewData,
  setViewData,
  handleEdit,
  companyAdmin,
  setData
}) {
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    if (element) {
      console.log(element);
      setFilteredData(element);
    }
  }, [element]);

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        height: "100vh",
        justifyContent: "space-between",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={() =>{ setViewData(false);setData({});}} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ p: 3, width: "100%", backgroundColor: "#fff", overflow: "auto" }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          Capital Goods Details
        </Typography>
        <Grid
          spacing={2}
          sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}
        >
          {inputData?.map((input) => {
            let value;

            if (input.fieldName.includes(".")) {
              value = getNestedValue(filteredData, input.fieldName);
            } else {
              value = filteredData?.[input.fieldName];
            }

            if (input.fieldName === "documents") return null;
            let displayValue;
            if (input.fieldName === "purchaseDate") {
              displayValue = formatDate(value);
            } else if (input.fieldName === "quantity") {
              const qtyValue = value?.value ?? value;
              const qtyUnit =
                filteredData?.quantityUnit || (typeof value === "object" ? value?.unit : "");
              displayValue =
                qtyValue === 0 || qtyValue === "0"
                  ? `${qtyValue}${qtyUnit ? ` ${qtyUnit}` : ""}`
                  : qtyValue
                    ? `${qtyValue}${qtyUnit ? ` ${qtyUnit}` : ""}`
                    : "-";
            } else if (
              input.fieldName === "country" &&
              Array.isArray(value)
            ) {
              // Handle legacy array data - take first element
              displayValue = value.length > 0 ? value[0] : "-";
            } else {
              // Prefer nested value if present (for { value, unit } shapes)
              const primitive = value?.value ?? value;
              displayValue =
                primitive === 0 || primitive === "0"
                  ? primitive
                  : primitive ?? "-";
            }
            return (
              <Grid item xs={12} sm={12} key={input.fieldName} mb={1}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: "bold",
                  wordBreak: "break-word",
                  }}
                >
                  {input.title}
                </Typography>
              <div style={{ wordBreak: "break-word" }}>{displayValue}</div>
              </Grid>
            );
          })}
        </Grid>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Documents (optional)
          </Typography>
          {element && element?.documents?.length > 0 ? (
            <Box
              display="flex"
              flexDirection="column"
              gap={2}
              sx={{ width: "100%" }}
            >
              <Box display="flex" flexWrap="wrap" gap={1}>
                {element?.documents
                  .filter((url) =>
                    ["png", "jpg", "jpeg"].includes(
                      url.split(".").pop().toLowerCase()
                    )
                  )
                  ?.map((url, index) => (
                    <DocumentItem key={`image-${index}`} url={url} />
                  ))}
              </Box>

              <Box display="flex" flexWrap="wrap" gap={1}>
                {element?.documents
                  .filter(
                    (url) =>
                      !["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                  )
                  ?.map((url, index) => (
                    <DocumentItem key={`file-${index}`} url={url} />
                  ))}
              </Box>
            </Box>
          ) : (
            <Typography>-</Typography>
          )}
        </Box>
        {!companyAdmin && (
          <Button
            variant="contained"
            sx={{ mt: 2, backgroundColor: "#0a3f73", textTransform: "none" }}
            onClick={() => handleEdit(element)}
          >
            Edit
          </Button>
        )}
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={viewData}
      onClose={() => {setViewData(false);setData({});}}
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      {list()}
    </Drawer>
  );
}

export default ViewData;
